module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">\r\n\t\tОписание\r\n\t</div>\r\n</div>\r\n<div class=\"popup-text\">{{html text}}</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\" data-dialog-result=\"ok\">Готово</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./modules/shops/page/templates/description-popup.html
// module id = KN3C
// module chunks = 10